export default (value) => {
    return value.toLowerCase()
}
